export default __webpack_public_path__ + "static/media/logoLine.09279da8.webp";